module.exports = __webpack_public_path__ + "img/float-activity-412.bd49f09b.png";